import { useAppSelector } from "../../app/hooks";

interface Props {
	title: string;
	legacyLink: string;
}

export default function NotImplemented(props: Props) {
	const { aspUrl, config } = useAppSelector((state) => state.site);

	return (
		<section>
			<h2 className="mt-12 mb-8">{props.title}</h2>
			<p className="mb-8">
				This feature has not yet been implemented in the new {config?.siteName} experience.
			</p>
			<p>
				<a
					id="legacy-feature-link"
					href={`${aspUrl}${props.legacyLink}`}
					target="_blank"
					rel="noopener noreferrer"
					className="text-lg text-primary-700 hover:text-primary-600">
					Go to {config?.siteName} Classic to use this feature.
				</a>
			</p>
		</section>
	);
}
